import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import { formatMonthYear } from '@atheneum/api/dist/lib'
import InvisibleIcon from '@components/Icon/Invisible'
import VisibleIcon from '@components/Icon/Visible'
import Radio from '@components/Radio'
import ReloadIcon from '@components/Icon/Reload'
import { showDialog } from '@components/Dialog'

import ToggleVisibility from './ToggleVisibility'

class EplExperiences extends Component {
  static propTypes = {
    form: PropTypes.object,
    positions: PropTypes.object,
    hiddenExperienceIds: PropTypes.arrayOf(PropTypes.number),
    staticData: PropTypes.object,
    experiencesHiddenToExpert: PropTypes.object,
    setExperiencesHiddenToExpert: PropTypes.func
  }

  experienceDates(experience) {
    if (!experience) return ''
    const startDateString = experience.startDate
      ? formatMonthYear(experience.startDate)
      : ''
    const endDateString = experience.endDate
      ? formatMonthYear(experience.endDate)
      : 'Now'
    let dates
    if (startDateString && endDateString) {
      dates = `(${startDateString} - ${endDateString})`
    } else if (endDateString) {
      dates = `(${endDateString})`
    } else {
      dates = ''
    }

    return `${dates}`
  }

  renderVisibilityAction = (experience, isActive) => {
    if (isActive) {
      return null
    }

    const { hiddenExperienceIds } = this.props

    if (hiddenExperienceIds.includes(experience.id)) {
      return (
        <InvisibleIcon
          className="m-l-md hide-show-all-position-icon"
          onClick={event =>
            this.toggleHideExperience({ event, experience, hide: false })
          }
        />
      )
    } else {
      return (
        <VisibleIcon
          className="m-l-md hide-show-all-position-icon"
          onClick={event =>
            this.toggleHideExperience({ event, experience, hide: true })
          }
        />
      )
    }
  }

  toggleHideExperience = ({ event, experience, hide }) => {
    event.stopPropagation()

    const { hiddenExperienceIds } = this.props

    if (hide) {
      hiddenExperienceIds.push(experience.id)
    } else {
      const index = hiddenExperienceIds.findIndex(
        experienceId => experienceId === experience.id
      )
      hiddenExperienceIds.splice(index, 1)
    }
  }

  refreshExperiences = async () => {
    const { form, staticData, positions, hiddenExperienceIds } = this.props
    const { dialogAlertType } = staticData

    await showDialog({
      title:
        'This will reset the relevant experience and any hidden experiences.',
      text: 'Are you sure you want to continue?',
      type: dialogAlertType.warning,
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No'
    })

    form.setFieldValue('cvId', form.values.expert.cv.id, false)
    form.setFieldValue('relevantExperienceId', null, false)
    form.setFieldValue('relevantExperience', null, false)

    positions.replace(form.values.expert.cv.experiences)
    hiddenExperienceIds.replace([])
  }

  render() {
    const { form, positions, staticData } = this.props
    const { PROJECT_STATUSES } = staticData.CONST

    const content = positions.map(experience => {
      const position = get(experience, 'position.name', 'N/A')
      const isActive = experience.id === form.values.relevantExperienceId
      const companyName = get(experience, 'company.name', 'Unknown company')

      const hiddenExperience = this.props.experiencesHiddenToExpert[
        experience.id
      ]
        ? this.props.experiencesHiddenToExpert[experience.id]
        : {}

      return (
        <div className="experience__item" key={experience.id}>
          <span
            onClick={e => {
              form.setFieldValue('relevantExperienceId', experience.id, false)
              form.setFieldTouched('relevantExperienceId', true)
            }}>
            <Radio checked={isActive} />
            <span
              className={`experience__text${
                hiddenExperience['position'] ? ' hidden-position-text' : ''
              }`}>
              {position}
            </span>
          </span>{' '}
          <ToggleVisibility
            invisible={hiddenExperience['position']}
            cyData={'toggle-hide-position'}
            onToggle={() =>
              this.props.setExperiencesHiddenToExpert(
                experience.id,
                'position',
                !hiddenExperience['position']
              )
            }
          />
          ,
          <span
            className={
              hiddenExperience['companyName'] && 'hidden-position-text'
            }>
            {companyName}
          </span>
          <ToggleVisibility
            invisible={hiddenExperience['companyName']}
            cyData={'toggle-hide-companyName'}
            onToggle={() =>
              this.props.setExperiencesHiddenToExpert(
                experience.id,
                'companyName',
                !hiddenExperience['companyName']
              )
            }
          />{' '}
          <span className={hiddenExperience['date'] && 'hidden-position-text'}>
            {this.experienceDates(experience)}
          </span>{' '}
          <ToggleVisibility
            invisible={hiddenExperience['date']}
            cyData={'toggle-hide-date'}
            onToggle={() =>
              this.props.setExperiencesHiddenToExpert(
                experience.id,
                'date',
                !hiddenExperience['date']
              )
            }
          />
          {this.renderVisibilityAction(experience, isActive)}
        </div>
      )
    })

    return (
      <ul className="experience__list">
        {content}
        {form.values.project.projectStatusId === PROJECT_STATUSES.OPEN &&
          form.values.expert.cv.id !== form.values.cvId && (
            <div
              className="experience__item refresh__experiences"
              onClick={this.refreshExperiences}>
              <span className="row--link">
                Not the right experiences? Fetch the latest data
              </span>
              <ReloadIcon />
            </div>
          )}
      </ul>
    )
  }
}

export default observer(EplExperiences)
